<section id="Terms-hero" class="w-100 text-light" 
         style="margin-top: 66px; background: linear-gradient(45deg, #1A2042, #173580);">
  <div class="container py-5">
    <div class="">
      <!-- Left: About intro -->
      <div class="text-center mb-4 mb-lg-0">
        <h1 class="fw-bold mb-4">Looking for a job in the software industry?</h1>
        <p class="lead mb-4 fw-medium">
          At ChalkBasket, we prepare you with the right skills, tools, and guidance to secure a job in the software industry and grow into a successful tech career  
        </p>
        <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3" (click)="navigateAndScroll('/home')">
          Sign up for free
        </button>
      </div>
    </div>
  </div>
</section>

<section class="legal-section">
 <div class="legal-content container-md mt-5 mb-5">
   <h3 class="text-center">Terms & Conditions</h3>
   <p class="effective-date text-center"><strong>Effective Date:</strong> September 25, 2025</p>
   <hr>

   <p>Welcome to ChalkBasket.com. By accessing or using our website, courses, and services, you agree to comply with the following Terms & Conditions. Please read them carefully.</p>

   <h4>1. Acceptance of Terms</h4>
   <p>By registering, accessing, or using our website and services, you confirm that you have read, understood, and agreed to these Terms & Conditions. If you do not agree, you should not use our services.</p>

   <h4>2. Eligibility</h4>
   <p>Our courses and services are designed for students, graduates, and undergraduates seeking skill development and career guidance. You must provide accurate information during registration and maintain its accuracy.</p>

   <h4>3. Use of Services</h4>
   <ul>
     <li>You agree to use our website and resources only for lawful purposes.</li>
     <li>You may not copy, distribute, modify, or resell our content without written permission.</li>
     <li>Misuse of our platform (including hacking, spamming, or unlawful activities) will lead to suspension or termination of access.</li>
   </ul>

   <h4>4. Intellectual Property</h4>
   <p>All content on ChalkBasket.com—including study materials, videos, designs, text, and logos—remains the property of ChalkBasket.com. Unauthorized use, reproduction, or distribution is prohibited.</p>

   <h4>5. Payments & Refunds</h4>
   <ul>
     <li>Fees for courses or services must be paid as per the instructions provided.</li>
     <li>Payments are non-refundable unless otherwise stated in a specific program’s policy.</li>
     <li>Any dispute regarding payments should be reported to us immediately.</li>
   </ul>

   <h4>6. Job Guarantee Disclaimer</h4>
   <p>Our training and mentorship aim to improve employability, but we do not guarantee job placement. Career success depends on individual effort, performance, and external factors beyond our control.</p>

   <h4>7. Limitation of Liability</h4>
   <p>We are not liable for any direct, indirect, or consequential damages arising from the use of our website, services, or resources. Students are responsible for applying the skills and knowledge gained.</p>

   <h4>8. Third-Party Links</h4>
   <p>Our website may contain links to third-party platforms. We are not responsible for the content, privacy policies, or services of such external sites.</p>

   <h4>9. Termination of Access</h4>
   <p>We reserve the right to suspend or terminate your access to our services if you violate these Terms & Conditions or engage in misuse of the platform.</p>

   <h4>10. Governing Law</h4>
   <p>These Terms & Conditions shall be governed by and construed in accordance with the laws of Maharashtra, India.</p>

   <h4>11. Updates to Terms</h4>
   <p>We may revise these Terms & Conditions at any time. Updates will be posted on this page with a revised effective date. Continued use of our services indicates your acceptance of the updated terms.</p>

   <h4>12. Contact Us</h4>
   <p>For questions regarding these <a routerLink="/terms-and-conditions"  class="link-offset-2 link-underline link-underline-opacity-0" (click)="scrollToTop()">Terms & Conditions</a>, please reach out to us via our <a routerLink="/contact" (click)="scrollToTop()"  class="link-offset-2 link-underline link-underline-opacity-0">Contact Us </a>page</p>
 </div>
</section>
